import Vue from 'vue'
import Router from 'vue-router'
import delivery from '@/Delivery.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'price',
      component: delivery
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: delivery
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js